import React from 'react'
import { Link } from 'react-router-dom'
import './Navbar.css'

const Navbar = () => {
  return (
    <div className='Navbar-parent'>
        <img src='logo.jpg' alt="Logo" className="logo" />
        <nav>
            <Link to="/">Home</Link>
            {/* <Link to="/about">About</Link>
            <Link to="/blog">Blogs</Link> */}
            <Link to="/contact">Contact</Link>
        </nav>
    </div>
  )
}

export default Navbar

